<div class="box ml-2 mr-2 order-summary-page">
  <div class="box-header">
    <div class="grid-filter">
      @if (userData && userData.roleId < 4) {
        <div class="dc-location">
          <span class="font-weight-bold">{{ 'DC Location' | translate }}:</span>
          @if (dcNumber) {
            <span> D0{{ dcNumber }}</span>
          }
        </div>
      }

      <form [formGroup]="poSummaryForm" class="filter-toolbar">
        @if (userData && userData.roleId > 3) {
          <mat-form-field class="store-no-field" appearance="outline">
            <mat-label>{{ 'Store No' | translate }}</mat-label>
            <mat-select formControlName="storeNumber" disableOptionCentering>
              @for (store of user.stores; track store) {
                <mat-option [value]="store.storeNumber">
                  {{ store.storeNumber }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        @if (userData && userData.roleId < 4) {
          <mat-form-field class="store-no-field" appearance="outline">
            <mat-label>{{ 'Store No' | translate }}</mat-label>
            <input matInput maxlength="6" formControlName="storeNumber" />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>
        }

        <button mat-raised-button type="button" [disabled]="!poSummaryForm.valid" (click)="filterdata(1)">
          {{ 'Filter' | translate }}
        </button>

        <button mat-raised-button type="button" class="advanced-search-btn" (click)="advancedSearch()">
          {{ 'Advanced Search' | translate }}
        </button>
      </form>

      <form [formGroup]="poSummaryForm">
        <section class="check-boxes order-summary-status">
          <mat-checkbox color="primary" matTooltip="{{ 'PendingTooltip' | translate }}" (change)="checkboxChange()" formControlName="poPending">{{ 'Pending' | translate }}</mat-checkbox>
          <mat-checkbox color="primary" matTooltip="{{ 'OverdueTooltip' | translate }}" (change)="checkboxChange()" formControlName="poOverDue">{{ 'Overdue' | translate }}</mat-checkbox>
          <mat-checkbox color="primary" matTooltip="{{ 'LateTooltip' | translate }}" (change)="checkboxChange()" formControlName="poLate">{{ 'Late' | translate }}</mat-checkbox>
          <mat-checkbox color="primary" matTooltip="{{ 'SignedTooltip' | translate }}" (change)="checkboxChange()" formControlName="poSigned">{{ 'Signed' | translate }}</mat-checkbox>
          <mat-checkbox color="primary" matTooltip="{{ 'ReportedTooltip' | translate }}" (change)="checkboxChange()" formControlName="poReported">{{ 'Reported' | translate }}</mat-checkbox>
        </section>
      </form>
    </div>
  </div>

  <div class="box-body mat-elevation-z8">
    <mat-table class="order-summary-table" [dataSource]="dataSource" matSort (matSortChange)="sortData($event)"
      matSortDirection="desc">

      @if (this.userData.roleId < 4) {
        <ng-container matColumnDef="storeNum" style="padding: 10%;">
          <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'Store #' | translate }} </mat-header-cell>
          <mat-cell *matCellDef="let element"> {{ element.storeNumber | translate }} </mat-cell>
        </ng-container>
      }

      <!-- Position Column -->
      <ng-container matColumnDef="statusName">
        <mat-header-cell matTooltip="{{ 'SignatureTooltip' | translate }}" *matHeaderCellDef mat-sort-header> {{ 'Signature Status' | translate }} </mat-header-cell>
        <mat-cell matTooltip="{{ (element.poStatus === 1 ? 'PendingTooltip'
          : (element.poStatus === 2 ? 'OverdueTooltip'
          : (element.poStatus === 3 ? 'LateTooltip' : (element.poStatus === 4 ? 'SignedTooltip'
          : (element.poStatus === 5 ? 'ReportedTooltip' : ''))))) | translate }}" *matCellDef="let element" [ngClass]="{ 'pending': element.poStatus === 1,
          'overdue': element.poStatus === 2, 'late': element.poStatus === 3 }">
          @if (element.poStatus !== 5) {
            <label> {{ element.statusName | translate }} </label>
          }
          @if (element.poStatus === 5) {
            <label> {{ 'Signed' | translate }} </label>
          }
        </mat-cell>
      </ng-container>

      <!-- Name Column -->
      <ng-container matColumnDef="purchaseOrder">
        <mat-header-cell matTooltip="{{ 'File Name' | translate }}" *matHeaderCellDef mat-sort-header disableClear> {{ 'File Name' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.purchaseOrder }} </mat-cell>
      </ng-container>

      <!-- Weight Column -->
      <ng-container matColumnDef="poPendingOrderDate">
        <mat-header-cell matTooltip="{{ 'CreatedOnDateTooltip' | translate }}" *matHeaderCellDef mat-sort-header disableClear> {{ 'Created On Date' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ element.poCreatedTime | date : dateTimeFormat : '' : 'fr' }} </mat-cell>
      </ng-container>

      <!-- Symbol Column -->
      <ng-container matColumnDef="poReceivedDate">
        <mat-header-cell matTooltip="{{ 'ReceivedDateTooltip' | translate }}" *matHeaderCellDef mat-sort-header disableClear> {{ 'Received Date' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let element">
        {{ element.receivedDate ? (element.receivedDate | date : dateFormat : '' : 'fr') : 'N/A' | translate }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="signedBy">
        <mat-header-cell matTooltip="{{ 'SignedByTooltip' | translate }}" *matHeaderCellDef mat-sort-header disableClear> {{ 'Signed By' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{ (element.poSignedBy) | translate }} </mat-cell>
      </ng-container>

      <ng-container matColumnDef="action">
        <mat-header-cell matTooltip="{{ 'ViewDetailsTooltip' | translate }}" *matHeaderCellDef> {{ 'Action' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element">
          <button mat-icon-button matTooltip="{{ 'ViewDetailsTooltip' | translate }}" (click)="viewPODetails(element)">
            <mat-icon>visibility</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns">
      </mat-row>
    </mat-table>
  </div>

  <div class="box-footer">
    <mat-paginator [length]="resultsLength" [pageSize]="15" showFirstLastButtons></mat-paginator>
  </div>
</div>
